// extracted by mini-css-extract-plugin
export default {"bg":"pricing_bg__p+V7D","pricebg":"pricing_pricebg__-NQOI","pricebg2":"pricing_pricebg2__5XoXo"};